import type { Region } from 'app/api/services/site-configs/types';

import type { SupportedLang } from 'app/lang';
import { FALLBACK_LANG } from 'app/lang/constants';

export function getRegionTitle(lang: SupportedLang, title?: Region['title']) {
  if (!title) {
    return null;
  }

  return title[lang] || title[FALLBACK_LANG];
}
